import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { takeOnce } from '@partners/utils';
import { Observable, tap } from 'rxjs';
import { DialogAdapter } from '../../dialogs';
import { EnvironmentService } from '../../environment';
import { NavigationAdapter } from '../services';

/**
 * this guard's main function is to prevent navigating back using the browser's "back" button
 * or by hitting the "backspace" key on the keyboard. in case navigation is denied - a we pop
 * a dialog specifying the restriction that "...navigating backward is not allowed"
 */
export const navigationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const navService = inject(NavigationAdapter);
  const dialogAdapter = inject(DialogAdapter);

  if (inject(EnvironmentService).isDevMode$$()) {
    return true;
  }

  const canNavigate$: Observable<boolean> = navService.canNavigateTo(state.url, route.params).pipe(
    takeOnce(),
    tap((canNavigate: boolean) => {
      !canNavigate && dialogAdapter.openIllegalNavigationAlert();
    })
  );

  return canNavigate$;
};
